import { numberToDecimalString as toDec } from 'commons/utils/number'
import { Alert, Icon } from 'components'
import { useSelector } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import { OverviewValue } from '../../../components/ModalOrderOverview/components'
import * as S from './styles'

export const OverviewContent = () => {
  const {
    generatedEdiOrders: {
      id_prcs_edi: idEdi,
      pedido_total: totalOrders,
      pedido_volume_pares: orderVolume,
      pedido_valor_total: orderValue,
      ordem_volume_pares: ovVolume,
      ordem_total: totalOvs,
      ordem_valor_total: ovsValue,
      volume_pares_aberto: pendingVolume,
      total_valor_aberto: pendingValue,
    },
  } = useSelector((state) => state.batchOrder)

  return (
    <div>
      <S.DescriptionContainer>
        <Alert
          fullWidth
          kind="success"
          message="Para acompanhá-las, acesse a área de gerenciamento."
          title={'OVs geradas com sucesso!'}
        />
        <span>
          Os pedidos gerados têm o número EDI <b>#{idEdi ?? ''}</b>. Confira abaixo a distribuição
          dos materiais:
        </span>
      </S.DescriptionContainer>
      <S.OverviewValues>
        <OverviewValue
          icon={<Icon color={theme.colors.primary.main} icon="box" size="16" />}
          iconColorBackground={theme.colors.alert.info.ligther}
          subtitle={`${toDec(orderVolume ?? 0)} pares -> ${toDec(totalOrders ?? 0)} pedidos`}
          title="Pedidos gerados"
          tooltip='Os pedidos gerados correspondem aos materiais solicitados, porém podem ter originado OVs ou ainda estar com status de "Em aberto".'
          value={orderValue}
        />
        <OverviewValue
          icon={<Icon color={theme.colors.alert.success.dark} icon="circle-check" size="16" />}
          iconColorBackground={theme.colors.alert.success[10]}
          subtitle={`${toDec(ovVolume ?? 0)} pares -> ${toDec(totalOvs ?? 0)} ${
            totalOvs === 1 ? 'ov' : 'ovs'
          }`}
          title="OVs geradas"
          tooltip="Materiais que atendem aos requisitos de cota, estoque e/ou valor mínimo, que estão aptos para gerar OVs e serem enviados ao SAP. "
          value={ovsValue}
        />
        <OverviewValue
          icon={<Icon color={theme.colors.neutral[60]} icon="pencil" size="16" />}
          iconColorBackground={theme.colors.neutral.softer}
          subtitle={`${toDec(pendingVolume ?? 0)} pares`}
          title="Em aberto"
          tooltip="Materiais que não geraram OVs durante a transação."
          value={pendingValue}
        />
      </S.OverviewValues>
    </div>
  )
}
